import api from '../utils/api';

class CollaboratorApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/collaborators', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  //   getGroup = () => {
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         const res = await api
  //           .get("/operators/group");
  //         resolve(res.data);
  //       } catch (error) {
  //         reject(error);
  //       }
  //     });
  //   };

  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post('/collaborators', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/collaborators/status/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/collaborators/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  
  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/collaborators/status/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/collaborators/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/collaborators/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const collaboratorApi = new CollaboratorApi();
export default collaboratorApi;
